module.exports = __webpack_public_path__ + "static/media/rocket-fail.b10f32f0.svg";